/* CRAVE theme — cart, variant selection, toast, drawer */
(function () {
  'use strict';

  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    const fmt = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
    return fmt
      .replace('{{amount}}', v)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', v.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());
  };

  const escapeHtml = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  const toastEl = document.getElementById('cart-toast');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = '✓ ' + msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.hidden = true; }, 2600);
  }

  async function fetchCart() {
    try {
      const r = await fetch((window.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' });
      return await r.json();
    } catch (e) { return null; }
  }

  async function changeLine(key, quantity) {
    try {
      const r = await fetch((window.Shopify.routes.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      return await r.json();
    } catch (e) { return null; }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = String(count).padStart(2, '0');
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawerEl = document.getElementById('cart-drawer');
  const drawerBody = drawerEl && drawerEl.querySelector('[data-cart-body]');
  const drawerFoot = drawerEl && drawerEl.querySelector('[data-cart-foot]');
  const drawerSubtotal = drawerEl && drawerEl.querySelector('[data-cart-subtotal]');

  function renderDrawer(cart) {
    if (!drawerEl || !cart) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="cart-drawer-empty">YOUR CART IS EMPTY.</div>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }
    const rows = cart.items.map((it) => {
      const img = it.image ? `<img src="${it.image.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png').replace('.webp', '_120x.webp')}" alt="${escapeHtml(it.product_title)}" width="72" height="72" loading="lazy">` : '';
      return `
        <div class="cart-line" data-line-key="${escapeHtml(it.key)}">
          <div class="cart-line-media">${img}</div>
          <div class="cart-line-info">
            <div class="cart-line-title">${escapeHtml((it.product_title || '').toUpperCase())}</div>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cart-line-variant">${escapeHtml(it.variant_title.toUpperCase())}</div>` : ''}
            <div class="cart-line-qty">
              <button type="button" class="cart-qty-btn" data-cart-qty data-delta="-1" aria-label="Decrease">−</button>
              <span class="cart-qty-n">${it.quantity}</span>
              <button type="button" class="cart-qty-btn" data-cart-qty data-delta="1" aria-label="Increase">+</button>
              <button type="button" class="cart-line-remove" data-cart-remove aria-label="Remove">REMOVE</button>
            </div>
          </div>
          <div class="cart-line-price">${money(it.final_line_price)}</div>
        </div>
      `;
    }).join('');
    drawerBody.innerHTML = rows;
    if (drawerFoot) drawerFoot.hidden = false;
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
  }

  function openDrawer() {
    if (!drawerEl) return;
    drawerEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    fetchCart().then((c) => { renderDrawer(c); if (c) updateCartCount(c.item_count); });
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function bindDrawer() {
    if (!drawerEl) return;
    drawerEl.addEventListener('click', async (e) => {
      const closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) { closeDrawer(); return; }
      const qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        const line = qtyBtn.closest('[data-line-key]');
        const key = line && line.getAttribute('data-line-key');
        const delta = Number(qtyBtn.dataset.delta || 0);
        const cur = Number(line.querySelector('.cart-qty-n').textContent || 1);
        const next = Math.max(0, cur + delta);
        const cart = await changeLine(key, next);
        if (cart) { renderDrawer(cart); updateCartCount(cart.item_count); }
        return;
      }
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const line = removeBtn.closest('[data-line-key]');
        const key = line && line.getAttribute('data-line-key');
        const cart = await changeLine(key, 0);
        if (cart) { renderDrawer(cart); updateCartCount(cart.item_count); }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawerEl.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
    // Nav cart icon opens drawer instead of navigating
    document.querySelectorAll('.nav-cart').forEach((el) => {
      el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
    });
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  }

  // Pack selector — swaps active variant on product card
  function bindPackSelectors(root) {
    root.querySelectorAll('.product-card').forEach((card) => {
      const packBtns = card.querySelectorAll('.pack-btn[data-variant-id]');
      const priceEl = card.querySelector('[data-price]');
      const crossEl = card.querySelector('[data-price-cross]');
      const perEl   = card.querySelector('[data-price-per]');
      const activeInput = card.querySelector('[data-active-variant]');

      packBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          packBtns.forEach((b) => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');
          const price = Number(btn.dataset.price);
          const compareAt = Number(btn.dataset.compareAt || 0);
          const size = Number(btn.dataset.packSize || 1);
          if (priceEl) priceEl.textContent = money(price);
          if (crossEl) {
            if (compareAt && compareAt > price) {
              crossEl.textContent = money(compareAt);
              crossEl.hidden = false;
            } else {
              crossEl.hidden = true;
            }
          }
          if (perEl) {
            const perUnit = size > 0 ? price / size : price;
            perEl.textContent = money(perUnit) + '/PC';
          }
          if (activeInput) activeInput.value = btn.dataset.variantId;
        });
      });
    });
  }

  // Add-to-cart buttons
  function bindCartButtons(root) {
    root.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const card = btn.closest('.product-card');
        const input = card && card.querySelector('[data-active-variant]');
        const variantId = input ? input.value : btn.dataset.variantId;
        const name = btn.dataset.productName || 'ITEM';
        const pack = (card && card.querySelector('.pack-btn[aria-pressed="true"]')) || null;
        const packLabel = pack ? pack.querySelector('.p').textContent : '';

        if (!variantId) { toast('OUT OF STOCK'); return; }

        btn.disabled = true;
        const orig = btn.textContent;
        btn.textContent = 'ADDING...';
        try {
          await addToCart(variantId, 1);
          const cart = await fetchCart();
          if (cart) { updateCartCount(cart.item_count); renderDrawer(cart); }
          toast(`${name}${packLabel ? ' · ' + packLabel : ''} ADDED`);
          openDrawer();
        } catch (err) {
          toast(err.message || 'ERROR');
        } finally {
          btn.disabled = false;
          btn.textContent = orig;
        }
      });
    });

    root.querySelectorAll('[data-buy-now]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const card = btn.closest('.product-card');
        const input = card && card.querySelector('[data-active-variant]');
        const variantId = input ? input.value : btn.dataset.variantId;
        if (!variantId) { toast('OUT OF STOCK'); return; }
        btn.disabled = true;
        const orig = btn.textContent;
        btn.textContent = 'LOADING...';
        try {
          await addToCart(variantId, 1);
          window.location.href = (window.Shopify.routes.root || '/') + 'checkout';
        } catch (err) {
          toast(err.message || 'ERROR');
          btn.disabled = false;
          btn.textContent = orig;
        }
      });
    });
  }

  // Reviews: "load all" progressive disclosure
  function bindLoadMoreReviews(root) {
    root.querySelectorAll('[data-reviews-show-all]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const grid = document.querySelector(btn.dataset.target);
        if (!grid) return;
        grid.querySelectorAll('[hidden]').forEach((el) => el.hidden = false);
        btn.remove();
      });
    });
  }

  function init(root) {
    root = root || document;
    bindPackSelectors(root);
    bindCartButtons(root);
    bindLoadMoreReviews(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init(document);
    bindDrawer();
    fetchCart().then((c) => { if (c) { updateCartCount(c.item_count); renderDrawer(c); } });
  });

  // Re-bind when theme editor re-renders a section
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
